import Vue from 'vue'

export const applyAxiosErrorInterceptor = (connection) => {
  connection.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      const errorMessage = error.message
      const isNotCancelScorm =
        errorMessage !== 'Upload file cancel by the user.'

      if (isNotCancelScorm && !error.response) {
        Vue.prototype.$toast(
          { text: 'Please check your internet connection.' },
          { displayDuration: 2000, theme: 'error' }
        )
      }
      return Promise.reject(error)
    }
  )
  return connection
}

export const isLandscapeMode = () =>
  [90, -90].includes(
    // "window.orientation" is deprecated but some mobile browsers still use it instead of "window.screen.orientation"
    typeof window.orientation === 'undefined'
      ? window.screen && window.screen.orientation.angle
      : window.orientation
  )
